import { allHtmlParsers } from '@utils/ast';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

/**
 * NB: Audio inputs are purely used as a way to add audio-files to a task. They
 * are NOT validatable and shouldn't be considered in validation.
 */

const makeUnvalidatableInput = bindUnvalidatableInputMaker();
const video23Input = makeUnvalidatableInput({
  parsers: {
    //
    // NB: Unfortunately the backend does not map video nodes properly to
    // related media and as such we do a best effort to extract related video.
    //
    // If this is not possible we return null.
    //
    video: (node, context) => {
      const inputContext = context.extra;
      const index = Array.from(node.parentElement?.children ?? []).filter(child => !Object.keys(allHtmlParsers).includes(child.tagName.toLowerCase())).indexOf(node);
      const matchingVideo = (() => {
        const src = node.getAttribute("src");
        const videos = inputContext?.media?.filter(it => it.type === "Video");
        const match = videos?.find(it => it.twentyThreeVideo.id === src);
        if (match) {
          return match;
        }
        const fallbackMatch = videos?.[0];
        if (videos?.length !== 1 || !fallbackMatch?.twentyThreeVideo) {
          return null;
        }
        return fallbackMatch;
      })();
      if (!matchingVideo) {
        return null;
      }
      return {
        id: `${index}`,
        nodeType: "video-23",
        twentyThreeVideo: matchingVideo.twentyThreeVideo
      };
    }
  }
});

export { video23Input };
//# sourceMappingURL=parser.video.js.map
